module.exports = __webpack_public_path__ + "static/assets/6cd3397308e11e6d925446470b906f2a.woff2";